/**
 * "Volunteering" section of the Ryerson Gives Back page
 * (`src/pages/why-ryerson/ryerson-commitment/ryerson-gives-back/index.tsx`, its only importer).
 * It renders the Environment, Health & Safety "Environment" layouts from
 * `../../EnvironmentHealthSafety/Environment/` (`EnvironmentDesktop.tsx` from `lg` up,
 * `EnvironmentMobile.tsx` below) with the copy in `./VolunteeringContent.tsx`, so a change to those
 * layouts changes this section.
 */
import React from "react";
import { Media } from "@ryerson/frontend.next";
import EnvironmentDesktop from "../../EnvironmentHealthSafety/Environment/EnvironmentDesktop";
import EnvironmentMobile from "../../EnvironmentHealthSafety/Environment/EnvironmentMobile";
import { useApplication } from "@ryerson/frontend.application";
import { VolunteeringContent } from "./VolunteeringContent";

/** Background choice; no file imports it. */
export type backgroundType = "primary" | "secondary";

/** Renders the section in the visitor's language, falling back to English. Takes no props. */
const Volunteering: React.FC = () => {
	const {
		localization: { language },
	} = useApplication();

	const volunteeringContent = VolunteeringContent[language] || VolunteeringContent.en;

	return (
		<>
			<Media lessThan="lg">
				<EnvironmentMobile {...volunteeringContent} />
			</Media>
			<Media greaterThanOrEqual="lg">
				<EnvironmentDesktop {...volunteeringContent} />
			</Media>
		</>
	);
};

export default Volunteering;
